// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YC56","footer":"styles_footer__3p3D8"};